import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  margin-top: 16px;
  > div {
    width: 100%;
  }
  > div + div {
    margin: 0 16px;
  }
  > div + div + div {
    margin: 0;
  }
`

interface IOptionProps {
  activeOption: boolean
}

export const Option = styled.div<IOptionProps>`
  cursor: pointer;
  &:hover {
    .ant-radio-inner {
      border-color: #9ecffa !important;
    }
  }
  label {
    float: left;
  }
  .ant-radio-inner {
    border: solid 2px #dcdcdc;
    height: 19px;
    width: 19px;
    &::after {
      top: 2.5px;
      left: 2.5px;
      width: 10px;
      height: 10px;
      background-color: #0085ff;
    }
  }
  ${(props) =>
    props.activeOption &&
    css`
      cursor: default !important;
      .ant-radio-inner {
        border-color: #0085ff !important;
        background-color: #e7f3fe;
      }
      .ant-radio-input {
        cursor: default !important;
      }
    `}
`

export const Title = styled.div`
  color: #363636;
  font-weight: 500;
  font-size: 14px;
  padding-left: 27px;
`

export const Subtitle = styled.div`
  color: #757575;
  font-size: 14px;
  padding-left: 27px;
  margin-top: 4px;
`
